var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-container"},[_c('div',{staticClass:"content"},_vm._l((_vm.homeNewsList),function(news){return _c('NewsCard',{key:news._id,attrs:{"news":news}})}),1),_c('div',{staticClass:"container"},[_c('router-link',{staticClass:"button-container",attrs:{"to":{
        name: 'news',
        params: {
          type: 'whats-on',
        },
      }}},[_c('button',{staticClass:"button"},[_vm._v(_vm._s(_vm.getTranslatedContent('SEE_ALL_NEWS')))])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }